<template>
  <div class="push-conditional-voucher-wrap tw-overlay">
    <div class="push-conditional-voucher">
      <img
        v-if="quest.image"
        class="push-conditional-voucher--banner"
        :src="quest.image"
      >
      <div
        v-else
        class="push-conditional-voucher--summary"
      >
        <div class="note">
          You got conditional vouchers
        </div>
        <div class="title">
          <span>{{ quest.title }}</span>
          <img src="~wap/views/voucher/images/indicator.png">
        </div>
        <div class="total-value">
          {{ $t('CURRENCY_UNIT') }} {{ quest.amount }}
        </div>
      </div>
      <div class="push-conditional-voucher--main">
        <div class="push-conditional-voucher--task">
          <template v-for="(item, index) in quest.display">
            <div
              :key="index"
              class="task-item"
            >
              <div class="task-item-inner flex">
                <div class="task-icon">
                  <img :src="item.icon">
                </div>
                <div class="task-content">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </template>
        </div>

        <a
          class="check-details v-button"
          :style="{
            background: hexColors[0],
            color: hexColors[1]
          }"
          @click="handleClick"
        >{{ quest.text || 'Check Details' }}</a>
      </div>
      <a
        class="close-btn"
        @click="handleClose"
      >
        <svg-icon icon-class="icon-clear" />
      </a>
    </div>
  </div>
</template>

<script>
import VDialog from 'fe-vui/dialog'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/clear.svg'

export default {
  name: 'ConditionalVoucher',
  props: {
    quest: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hexColors() {
      const { hex } = this.quest
      if (!hex) return []
      if (hex[0] === '[') {
        return JSON.parse(hex)
      } else {
        return [hex]
      }
    }
  },
  methods: {
    handleClose() {
      modalHelper.beforeClose()
      VDialog.close()
      this.$emit('close')
    },
    handleClick() {
      window.mstrace('push_quest_click')
      if (this.quest.wapLink) location.href = this.quest.wapLink // 新用户需求优化：有链接才跳转，无则无响应
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.push-conditional-voucher-wrap {
  z-index: 9999;
}

.push-conditional-voucher {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  width: 280px;
  border-radius: 4px;
  transform: translate(-50%, -50%);

  .close-btn {
    position: absolute;
    bottom: -58px;
    left: 50%;
    width: 36px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    transform: translateX(-50%);

    .svg-icon {
      color: #fff;
      font-size: 24px;
    }
  }

  .task-icon {
    position: relative;
    display: flex;
    width: 30px;
    height: 30px;
    flex: none;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #fff;

    img {
      display: block;
      width: 18px;
      height: 18px;
      filter: grayscale(90%);
      opacity: 0.35;
    }

    .svg-icon {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 10px;
    }
  }

  &--banner {
    width: 100%;
  }

  &--summary {
    position: relative;
    padding: 44px 10px 20px;
    border-radius: 4px;
    background: url("~wap/views/voucher/images/mark.png") no-repeat right -60px top -10px, linear-gradient(135deg, #ffca27 0%, #ff8320 100%);
    background-size: auto 223px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 36%);

    .note {
      position: absolute;
      top: 0;
      left: 50%;
      height: 20px;
      padding: 0 8px;
      background: #ff751a;
      color: #fff;
      font-size: 12px;
      line-height: 20px;
      transform: translateX(-50%);
      white-space: nowrap;

      &::after,
      &::before {
        position: absolute;
        top: 0;
        width: 0;
        height: 0;
        border-top: 20px solid #ff751a;
        border-right: 6px solid transparent;
        border-bottom: 0 solid transparent;
        border-left: 6px solid transparent;
        content: "";
      }

      &::before {
        left: -6px;
      }

      &::after {
        right: -6px;
      }
    }

    .title {
      color: #fff;
      font-size: 18px;
      line-height: 22px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 50%);

      img {
        width: 20px;
      }
    }

    .total-value {
      margin-top: 8px;
      color: #000;
      font-size: 24px;
      font-style: italic;
      font-weight: 500;
      line-height: 1;
    }
  }

  &--main {
    padding-bottom: 10px;
    border-radius: 0 0 4px 4px;
    background: #fff;
  }

  &--task {
    position: relative;
    overflow: auto;
    max-height: 219px;
    padding: 20px 10px;

    .task-item {
      position: relative;
      height: 66px;

      &:last-child {
        height: auto;

        &::after {
          display: none;
        }
      }

      &::after {
        position: absolute;
        bottom: 3px;
        left: 0;
        width: 30px;
        color: #1b1b1b;
        content: "···";
        font-size: 24px;
        line-height: 30px;
        text-align: center;
        transform: rotate(90deg);
      }
    }

    .task-icon {
      background: #f8f8f8;
    }

    .task-content {
      display: flex;
      align-items: center;
      margin-left: 9px;
      color: #333;
      font-size: 12px;
      line-height: 14px;
    }
  }

  .check-details {
    width: auto;
    height: 44px;
    margin: 0 10px;
    font-size: 16px;
    line-height: 44px;
  }
}
</style>
